import { AlertTriangle } from 'lucide-react'
import type { ReactNode } from 'react'

import { DiagnosticCopy } from '@krp/ui-kit'

import type { ShownError } from '../model/types'
import './duplicates.css'

/**
 * Ошибка целиком (О-1): заголовок, текст службы дословно, код и идентификатор запроса и «Копировать» — для передачи
 * администратору. Таймера нет: ошибка уходит, когда человек повторил действие или закрыл экран.
 */
export function ErrorBlock({ error, action }: { error: ShownError; action?: ReactNode }) {
  return (
    <div className="dup-error" role="alert">
      <AlertTriangle size={18} aria-hidden="true" />
      <div>
        <p className="dup-error__title">{error.title}</p>
        <p>{error.message}</p>
        <p className="dup-error__meta">
          Код: {error.code}
          {error.requestId !== null && ` · запрос ${error.requestId}`}
        </p>
        <div className="dup-error__actions">
          {action}
          <DiagnosticCopy text={error.report} label="Копировать" />
        </div>
      </div>
    </div>
  )
}
